/**
* DevExpress Dashboard (_dashboard-layout-mode-helper.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import devices from 'devextreme/core/devices';
import { touch } from 'devextreme/core/utils/support';
class DashboardLayoutModeHelper {
    static get isMobile() {
        if (DashboardLayoutModeHelper._forceMobileMode !== null)
            return DashboardLayoutModeHelper._forceMobileMode;
        return devices.current().phone || devices.current().tablet;
    }
    static set isMobile(value) {
        DashboardLayoutModeHelper._forceMobileMode = value;
    }
    static get isTouch() {
        if (DashboardLayoutModeHelper._forceTouchMode !== null)
            return DashboardLayoutModeHelper._forceTouchMode;
        return touch;
    }
    static set isTouch(value) {
        DashboardLayoutModeHelper._forceTouchMode = value;
    }
}
DashboardLayoutModeHelper._forceTouchMode = null;
DashboardLayoutModeHelper._forceMobileMode = null;
export { DashboardLayoutModeHelper };
